import { CurrencyPipe, DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DictionaryService {
  datePipe = new DatePipe('pt');
  currencyPipe = new CurrencyPipe('pt');
  constructor() { }

  dictionary: any = {
    admin: 'Administrador',
    class: 'Turma',
    classDate: 'Data da aula',
    classes: 'Turmas',
    classSummary: 'Assunto',
    createdAt: 'Criada em',
    date: 'Data',
    department: 'Departamento',
    desc: 'Descrição',
    description: 'Descrição',
    endDateEffective: 'Vigente até',
    eventName: 'Nome',
    eventType: 'Tipo',
    file: 'Arquivo',
    groupAccess: 'Grupo de acesso',
    hasHomeWork: 'Dever de casa',
    message: 'Mensagem',
    name: 'Nome',
    pdf: 'Arquivo',
    period: 'Período',
    policyName: 'Categoria',
    read: 'Leitura',
    role: 'Função',
    school_calendar: 'Calendário escolar',
    schoolLevel: 'Nível de ensino',
    schoolYear: 'Ano de escolaridade',
    status: 'Situção',
    student: 'Aluno',
    subjects: 'Disciplinas',
    teacher: 'Professor',
    type: 'Tipo',
    write: 'Escrita',
  };

  mapValue(key: string, value: any) {
    let mappedString: string | null;
    switch (key) {
      case 'phone':
      case 'cellPhone':
        mappedString = this.formatString('(XX) XXXXX-XXXX', value);
        break;
      case 'cpf':
        mappedString = this.formatString('XXX.XXX.XXX-XX', value);
        break;

      case 'plate':
        mappedString = this.formatString('XXX-XXXX', value);
        break;
      case 'car':
        mappedString = 'Automóvel';
        break;
      case 'createdAt':
      case 'updatedAt':
      case 'classDate':
      case 'date':
        mappedString = value.toDate()
          ? this.datePipe.transform(value.toDate(), 'dd/MM/yyyy')
          : this.datePipe.transform(value, 'dd/MM/yyyy');
        break;
      case 'amount':
        mappedString = this.currencyPipe.transform(value, 'R$');
        break;
      case 'totalToPay':
        mappedString = this.currencyPipe.transform(value, 'R$');
        break;
      case 'status':
      case 'role':
      case 'department':
        mappedString = value.desc;
        break;
      case 'sender':
      case 'groupAccess':
      case 'class':
      case 'classes':
      case 'subjects':
      case 'schoolLevel':
      case 'eventType':
        mappedString = value.name;
        break;
      case 'hasHomeWork':
        mappedString = value ? 'Sim' : 'Não';
        break;

      default:
        mappedString = value;
        break;
    }

    return mappedString;
  }

  formatString(mask: string, value: string) {
    let r = '';
    for (let im = 0, is = 0; im < mask.length && is < value.length; im++) {
      r += mask.charAt(im) === 'X' ? value.charAt(is++) : mask.charAt(im);
    }
    return r;
  }
}
